// extracted by mini-css-extract-plugin
export default {"main":"App_main__9rbZ-","mapContainer":"App_mapContainer__Qm+3G","mainTitle":"App_mainTitle__AUvh2","title":"App_title__+LZQ+","span":"App_span__5e-Bs"};